module.exports = __webpack_public_path__ + "img/win-icon2.77baadf.png";